module.exports = __webpack_public_path__ + "img/Frame 70785.150d5d59.png";